module.exports = __webpack_public_path__ + "static/media/UploadSmilingFolder.0312cdfb.svg";